const VIETNAM_LOCALE = 'vi-VN' as const;
const MILLION_THRESHOLD = 1_000_000;
const MILLION_DIVISOR = 1_000_000;

/**
 * Format currency amount to Vietnamese Dong format
 */
export const formatCurrency = (amount: number): string => {
  return `${new Intl.NumberFormat(VIETNAM_LOCALE).format(amount)} ₫`;
};

/** Đọc số tiền có hoặc không có dấu phân cách hàng nghìn. */
export const parseCurrencyInput = (value: string | number): number | null => {
  if (typeof value === 'number') return Number.isFinite(value) ? value : null;

  const input = value.trim().replace(/\s|₫|đ|vnd/gi, '');
  if (!/^\d[\d.,]*$/.test(input)) return null;

  let normalized: string;
  if (/^\d{1,3}([.,]\d{3})+([.,]\d{1,2})?$/.test(input)) {
    const lastSeparator = Math.max(input.lastIndexOf('.'), input.lastIndexOf(','));
    const fractionLength = input.length - lastSeparator - 1;
    normalized = fractionLength <= 2
      ? `${input.slice(0, lastSeparator).replace(/[.,]/g, '')}.${input.slice(lastSeparator + 1)}`
      : input.replace(/[.,]/g, '');
  } else if (/^\d+[.,]\d{1,2}$/.test(input)) {
    normalized = input.replace(',', '.');
  } else if (/^\d+$/.test(input)) {
    normalized = input;
  } else {
    return null;
  }

  const amount = Number(normalized);
  return Number.isFinite(amount) ? amount : null;
};

/**
 * Format number with abbreviation (M for millions)
 */
export const formatNumber = (num: number): string => {
  if (num >= MILLION_THRESHOLD) {
    return `${(num / MILLION_DIVISOR).toFixed(1)}M`;
  }
  return num.toLocaleString(VIETNAM_LOCALE);
};

const ROLE_MAP = {
  hr: 'Nhân sự',
  ceo: 'Giám đốc',
  staff: 'Nhân viên',
  admin: 'Quản trị viên',
  employee: 'Nhân viên',
  manager: 'Quản lý',
} as const satisfies Record<string, string>;

/**
 * Convert role from English to Vietnamese
 */
export const formatRole = (role: string | null | undefined): string => {
  if (!role) return '';
  
  const normalizedRole = role.toLowerCase().trim();
  return ROLE_MAP[normalizedRole as keyof typeof ROLE_MAP] || role;
};
